import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { ClienteTributario, validarCliente } from "@/components/ClienteTributario";
import TransporteFields, { validarTransporte } from "@/components/TransporteFields";
import ReferenciasFields, { validarReferencias } from "@/components/ReferenciasFields";

/** Datos tributarios del cliente para la factura de la caja (modal, para no tapar las formas de pago). */
export function FacturaClienteModal({ open, onOpenChange, value, onChange, obs, onObs, transporte, onTransporte, referencias, onReferencias, storeId }) {
  const listo = () => {
    const falta = validarCliente(value) || validarTransporte(transporte) || validarReferencias(referencias);
    if (falta) { toast.error(falta); return; }
    onOpenChange(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl rounded-2xl max-h-[92vh] overflow-y-auto" data-testid="pos-factura-modal"
        onKeyDown={(e) => { e.stopPropagation(); if (e.key === "Enter" && e.target.tagName !== "BUTTON") { e.preventDefault(); listo(); } }}>
        <DialogHeader><DialogTitle>Datos del cliente para la factura</DialogTitle></DialogHeader>
        <ClienteTributario conTitulos value={value} onChange={onChange} prefix="pos-factura"
          className="grid sm:grid-cols-2 gap-3" inputClass="h-11 rounded-xl text-base" />
        <label className="block space-y-1">
          <span className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500">Comentario para la factura (opcional)</span>
          <Input data-testid="pos-factura-observaciones" value={obs} onChange={(e) => onObs(e.target.value)} className="h-11 rounded-xl" />
        </label>
        {onReferencias && <ReferenciasFields value={referencias} onChange={onReferencias} prefix="pos-factura-ref" compact />}
        {onTransporte && <TransporteFields value={transporte} onChange={onTransporte} prefix="pos-factura-transporte" compact storeId={storeId} />}
        <Button onClick={listo} data-testid="pos-factura-modal-listo" className="h-12 rounded-xl bg-sky-600 hover:bg-sky-700 font-bold">
          Listo, volver al cobro
        </Button>
      </DialogContent>
    </Dialog>
  );
}
